// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I32gmwa_J6p2p1zoNZA4 {
  background-color: var(--page-color);
  border: 1px solid var(--card-color);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.1);
}

.xHh5ut5SRScTK6HvU1sr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5em;
  border-bottom: 1px solid var(--card-color);
  background-color: var(--card-color);
  color: var(--text-color);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  margin: -1px -1px 0 -1px;
}

.wLWL53gmTH6wSza6jcrf {
  font-size: 1.2em;
  font-weight: 600;
  font-family: var(--header-font);
  color: var(--text-color);
  margin: 0.5em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Card.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,4DAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,0CAA0C;EAC1C,mCAAmC;EACnC,wBAAwB;EACxB,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".card {\n  background-color: var(--page-color);\n  border: 1px solid var(--card-color);\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.1);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5em;\n  border-bottom: 1px solid var(--card-color);\n  background-color: var(--card-color);\n  color: var(--text-color);\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n  margin: -1px -1px 0 -1px;\n}\n\n.title {\n  font-size: 1.2em;\n  font-weight: 600;\n  font-family: var(--header-font);\n  color: var(--text-color);\n  margin: 0.5em;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `I32gmwa_J6p2p1zoNZA4`,
	"cardHeader": `xHh5ut5SRScTK6HvU1sr`,
	"title": `wLWL53gmTH6wSza6jcrf`
};
export default ___CSS_LOADER_EXPORT___;
